import { useDispatch, useSelector } from "react-redux";
import { signOutSuccess } from "../../store/auth";
import { ROUTE_DASHBOARD, ROUTE_PUBLIC_REGISTER, ROUTE_SIGNIN } from "../app/routes";
import { Redirect } from "react-router";
import { makeContinueUrl } from "../../utils/url";

export default function Unauthorized() {
	const loc = window.location;
	const dispatch = useDispatch();
	const auth = useSelector((state) => state.auth);
	let $continue = false;

	if (auth.signingIn) {
		return <></>;
	}

	dispatch(signOutSuccess);

	if (loc !== "/") {
		$continue = true;
	}

	const redirectTo = $continue ? makeContinueUrl(ROUTE_DASHBOARD) : ROUTE_PUBLIC_REGISTER;

	return <Redirect to={ROUTE_PUBLIC_REGISTER} />;
}
